const $ = window.jQuery;
$(document).ready(function(){

    var officeSelect = $('.js-rw-office-select-widget-input');

    officeSelect.on('select2:select', function(e){

        let data = e.params.data;
        let baseURL = window.baseURL;
        let id = e.params.data.id;
        if(!baseURL) { console.error('Invalid Request Parameters to send office select request', {id, baseURL}); return false; }
        
        console.log(data);
        
        let requestURL = baseURL + '/set-office';


        axios.post(requestURL, { selected_office: id }).then(response => {


            if(response.status == 200){
                window.location.reload(true);
            } else {
                console.error('invalid response');
            }

        }).catch(function(response){ 
            console.error(response);
        });

        // window.dataLayer.push({officeSelectSelection: data.text});
        
        
    });

    officeSelect.select2();
    
});